import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { breadcrumnsCodes } from 'src/app/shared/constants/global.constants';
import { LoaderService } from 'src/app/Loader/loader.service';
import { DatePipe } from '@angular/common';

import { BreadcrumbService } from 'src/app/shared/Breadcrumb/breadcrumb.service';
import { MenuItem, MessageService } from 'primeng/api';
import { UserService } from '../../Services/user.service';
import { PrivilegeService } from 'src/app/Reusable/privilege.service';
import { Privileges } from 'src/app/shared/constants/privileges.constants';
import { TabAndStateService } from 'src/app/shared/TabAndStateService/TabAndState.Service';
import { AuthCommonService } from 'src/app/shared/Authentication/auth.service';

@Component({
  selector: 'app-user-role-mapping-list',
  templateUrl: './user-role-mapping-list.component.html',
  styleUrls: ['./user-role-mapping-list.component.css']
})

export class UserRoleMappingListComponent {
  usersList: any = [];
  usersListCopy: any = [];
  groupTypeList: any = [];
  groupList : any = [];
  assignedRolesList : any = [];
  _enumBreadcrumb: any;
  editPrivilege:boolean=false;
  filterDetailsModel = new userroleFilterDetails();
  showHideFiltersControls: boolean = false;
  totalRecordCount: number = 0;
  filteredRecordCount: number = -1;
  
  constructor(private privilegeService: PrivilegeService,private _userService:UserService,
    private _loaderService: LoaderService, 
    private _router:Router,
    private _datePipe: DatePipe,
    private breadcrumbService: BreadcrumbService,
    private tabAndStateService: TabAndStateService,
    private _authService:AuthCommonService,
    private messageService: MessageService,) {

  }
  ngOnInit() {
    this._enumBreadcrumb = breadcrumnsCodes;
    this.generateBreadcrumb();
    this.GetUsersList();
   
    this.BindPrivileges();
  }
  BindPrivileges(){
    const hasPermission = (privilege: Privileges) => this.privilegeService.hasPermission(privilege);
    this.editPrivilege = hasPermission(Privileges.AssignRolesUsers);
    }
  GetUsersList(){
    this._loaderService.showLoader();
    this._userService.GetUserList().subscribe((res:any)=>{
      if(res.status){
      
      this.usersList=res.data;
      this.totalRecordCount=this.usersList.length;
      this.usersListCopy=[...this.usersList];
      this.groupTypeList = this.extractUniqueValues(this.usersList, 'groupType').map(obj => ({ label: obj }));
       let groupdata = this.extractUniqueValues(this.usersList, 'group');
      let assignroledata = this.extractUniqueValues(this.usersList, 'assignedRoles');
      let grouplistdata = groupdata.flatMap((group:any) => group.split(',').map((item:any) => item.trim())) .filter(item => item.length > 0);
      let assignedRolesListdata= assignroledata.flatMap((role:any) => role.split(',').map((item:any) => item.trim())) .filter(item => item.length > 0);
       this.groupList = Array.from(new Set(grouplistdata)).map(obj => ({ label: obj }));
       this.assignedRolesList = Array.from(new Set(assignedRolesListdata)).map(obj => ({ label: obj }));
      this.tabAndStateService.setPaginationDataSource(this.usersList);
      }
      this.getAdminCenterUserList();
      this._loaderService.hideLoader();
    });
  }
  extractUniqueValues(array: any, key: any)
  {
    return Array.from(new Set(array.map((item: any) => item[key])));
  }
ViewRoleMapping(userId:number) 
{
  this._router.navigate(['/ViewUserRolesMapping', userId]);
}
EidtRoleMapping(userId:number)
{
  this._router.navigate(['/EditUserRolesMapping',userId])
}
generateBreadcrumb() {
  this.breadcrumbService.generateBreadcrumb(this._enumBreadcrumb.UL);
}
getBreadcrumbs(): MenuItem[] {
  return this.breadcrumbService.getBreadcrumbs();
}


onfilter()
  {
    this.usersList=[...this.usersListCopy];
    
  if(this.filterDetailsModel.Key!=undefined){
    this.usersList = this.usersList.filter((a:any) => a.firstName.toLowerCase().indexOf(this.filterDetailsModel.Key?.toLowerCase()) !== -1 || a.lastName.toLowerCase().indexOf(this.filterDetailsModel.Key?.toLowerCase()) !== -1|| a.emailId.toLowerCase().indexOf(this.filterDetailsModel.Key?.toLowerCase()) !== -1);
  }
    if(this.filterDetailsModel.GroupType &&  this.filterDetailsModel.GroupType.length > 0) {
      this.usersList = this.usersList.filter((c:any) => this.filterDetailsModel.GroupType.includes(c.groupType));

    }
    if (this.filterDetailsModel.Group && this.filterDetailsModel.Group.length > 0) {
      let uniquegroupIds = new Set();
      let groupData: any[] = [];

      this.usersList.forEach((gr:any) => {
        let GroupArray = gr.group.split(',').map((item: any) => item.trim());
        let hasMatchingService = GroupArray.some((c: any) => this.filterDetailsModel.Group.includes(c));
        if (hasMatchingService && !uniquegroupIds.has(gr.id)) {
          groupData.push(gr);
          uniquegroupIds.add(gr.id);
        }
      });
      this.usersList = groupData;

    }
    if (this.filterDetailsModel.AssignedRoles && this.filterDetailsModel.AssignedRoles.length > 0) {
      let uniqueroleids = new Set();
      let roleData: any[] = [];

      this.usersList.forEach((gr:any) => {
        let roleArray = gr.assignedRoles.split(',').map((item: any) => item.trim());
        let hasMatchingrole = roleArray.some((c: any) => this.filterDetailsModel.AssignedRoles.includes(c));
        if (hasMatchingrole && !uniqueroleids.has(gr.id)) {
          roleData.push(gr);
          uniqueroleids.add(gr.id);
        }
      });
      this.usersList = roleData;

    }
    
    this.filteredRecordCount=this.usersList.length;
    this.tabAndStateService.setPaginationDataSource(this.usersList);
  }
  showfilter()
  {
    this.showHideFiltersControls = !this.showHideFiltersControls;
  }
clearFilters(){
  this.filterDetailsModel={
    Key:'',
    FirstName: '',
    LastName: '',
    Email:'',
  GroupType:  [],
  Group:[],
  AssignedRoles:[]
  
   }
   
  this.usersList=this.usersListCopy;
  this.filteredRecordCount=this.usersList.length;
  this.tabAndStateService.setPaginationDataSource(this.usersList);
}

adminUserList:any;
getAdminCenterUserList(){
  this._authService.getAdminCenterUsers().subscribe((res) => {
    this.adminUserList=res;
    // Iterate through usersList and update the values directly
this.usersList.forEach((user: any) => {
  // Find the matching record in adminUserList
  const matchingAdminUser = this.adminUserList.data.data.find(
    (adminUser: any) => adminUser.email === user.emailId
  );

  // If a match is found, update locked and status
  if (matchingAdminUser) {
    user.isLocked = matchingAdminUser.locked === 1?'Yes':'No'; // Convert 1 to true, 0 to false
    user.isActive = matchingAdminUser.status === 1?'Yes':'No'; // Convert 1 to true, 0 to false
  }
});

  });
}

// deletedAdminUserList:any;
// getAdminCenterDeletedUserList(){
//   this._authService.getAdminCenterDeletedUsers().subscribe((res) => {
//     this.deletedAdminUserList=res;
//   });
  
// }

refreshClick(){
  //this.getAdminCenterUserList();
  this._loaderService.showLoader();
  this._authService.getAdminCenterUsers().subscribe((res) => {
    this.adminUserList=res;
    this.syncUsers();
  });
  
}

userModel:any;
userListModel:any[]=[];
syncUsers() {
  this.userListModel=[];
  if (this.adminUserList && this.adminUserList.data && Array.isArray(this.adminUserList.data.data)) {
    this.adminUserList.data.data.forEach((item: any) => {
      const userModel = {
        EmailId: item.email,
        UserName: item.userName,
        FirstName: item.fullName.split(" ")[0] || '',
        LastName: item.fullName.split(" ")[1] || '',
        CreatedBy: this.privilegeService.getLoginUserId(),
       // createdDate: item.createdDate,
      };
      this.userListModel.push(userModel);
    });
  } 

  this._userService.SyncUserListWithAdminCenter(this.userListModel)
  .subscribe(
    (res: any) => {
      // Success block
      this.messageService.add({ key: 'tc', severity: 'success', summary: 'Refresh Complete', detail: '' });
      this.GetUsersList();
      this._loaderService.hideLoader();
    },
    (error: any) => {
      // Error block
      this.messageService.add({ key: 'tc', severity: 'error', summary: 'Refresh Failed', detail: 'Failed to sync user list. Please try again.' });
    }
  );

}


}
export class userroleFilterDetails{
  Key?:string;
  FirstName?: string;
  LastName?:string;
  Email?:string;
  GroupType?: any;
  Group?:any;
  AssignedRoles:any;

}